// extracted by mini-css-extract-plugin
module.exports = {"FullPageLoader":"styles_FullPageLoader__wpFiY"};